import type { PlanId } from "@/data/meal-plan";
import { fetchFriendPlan, fetchPresets, SELF_SCOPE, type OwnerContext, type WeekScope } from "./api";
import { weekPathPrefix } from "./week-paths";

/**
 * Whose weeks a `WeekPlanProvider` shows and edits: mine, or an accepted
 * friend's (friend mode). A friend's plan isn't known up front; the provider
 * loads it with the friend's presets.
 */
export type WeekOwner =
  | { kind: "self"; userId: number; username: string; planId: PlanId }
  | { kind: "friend"; friendId: number; username: string };

export function ownerScope(owner: WeekOwner): WeekScope {
  return owner.kind === "self" ? SELF_SCOPE : { kind: "friend", friendId: owner.friendId };
}

/** "/week" or "/friend/:id/week": prefix of every link inside the owner's weeks. */
export function ownerBasePath(owner: WeekOwner): string {
  return weekPathPrefix(owner.kind === "self" ? null : owner.friendId);
}

/**
 * The plan and weekday presets the owner's weeks are planned with: mine from
 * my session and `/api/presets`, a friend's from `/api/friends/:id/plan`.
 */
export async function fetchOwnerContext(owner: WeekOwner): Promise<OwnerContext> {
  if (owner.kind === "self") return { planId: owner.planId, presets: await fetchPresets() };
  return fetchFriendPlan(owner.friendId);
}
